import { JsonLd } from "react-schemaorg";
import { getBreadcrumbsItemListElement } from "../../../functions/schemaHelpers";
import parsePrices from "../../../functions/parseSWPrices";
import { useContext } from "react";
import { SessionContext } from "../../providers/session";
import { getProductMetaDescription } from "../../../functions/productOps";
import { useTranslation } from "../../../tools/i18n";

export default function ProductJsonLD({product, media, breadcrumb, meta, prices, canonicalPath}) {
    const session = useContext(SessionContext);
    const { t } = useTranslation(['product-info']);

	function getImagesForSchema() {
		let images = media.map((image) => {
			return image.media.url;
		}).filter((image) => {
			return !(product.cover && product.cover.id === image.id);
		});

		return images || [];
	}

	function getOffersSchema() {
		const prices = parsePrices(product.calculatedPrices && product.calculatedPrices.length > 0 ? product.calculatedPrices[0] : product.calculatedPrice);
		const basePath = meta ? meta.basePath : '/';

		return {
			"@type": "Offer",
			"url": basePath + canonicalPath,
			"priceCurrency": session.config.currency,
			"price": prices.price,
			"itemCondition": "https://schema.org/NewCondition",
			"availability": product.available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
		}
	}

    function getJsonLd() {
		let item = {
			"@context": "https://schema.org",
			"@type": "Product",
			"name": product.translated.name,
			"sku": product.productNumber,
			"description": getProductMetaDescription({product, prices, translation: t}),
			"image": getImagesForSchema(),
			"offers": getOffersSchema()
		}

		if(product.manufacturer) {
			item['brand'] = {
				"@type": "Brand",
				"name": product.manufacturer.translated.name
			}
		}

		return {
			"@context": "https://schema.org",
			"@type": "Webpage",
			"breadcrumb": {
				'@type': 'BreadcrumbList',
				itemListElement: getBreadcrumbsItemListElement(breadcrumb, meta.basePath)
			},
			"mainEntity": item
		};
	}

    return <JsonLd item={getJsonLd()}/>;
}